import { INIT_STATE } from '../../common/reducers/AppReducer';
import { createSelector } from 'reselect';
import type { App, AppReducer } from '../../common/types/appTypes';
import type { RootState } from 'client/js/redux';

export function getState(state: RootState): AppReducer {
  return (state && state.app) || INIT_STATE;
}
export const getCurrentAppId: (state: RootState) => string | null | undefined = createSelector(
  getState,
  (appState) => (appState && appState.app_id) || undefined
);
export const getCurrentApp: (state: RootState) => App | null | undefined = createSelector(
  getState,
  (state) => (state && state.currentApp) || undefined
);
export const getCurrentAppName: (state: RootState) => string | undefined = createSelector(
  getCurrentApp,
  (currentApp) => (currentApp && currentApp.name) || undefined
);
export const getCurrentAppLocalCurrency: (state: RootState) => string = createSelector(
  getCurrentApp,
  (currentApp) => (currentApp && currentApp.local_currency) || 'USD'
);
export const selectIsTmtaEnabled: (state: RootState) => boolean = createSelector(
  getCurrentApp,
  (currentApp) => !!currentApp && !!currentApp.tmta_enabled
);
export const isAppInitializationComplete: (state: RootState) => boolean = createSelector(getState, (state) => {
  if (!state.initializationComplete) {
    return false;
  }

  return `${state.initializationComplete}` == '1';
});
export const selectSkAdNetworkEnabled: (state: RootState) => boolean | null | undefined = createSelector(
  getCurrentApp,
  (app) => {
    return app?.sk_ad_network_enabled;
  }
);
export const selectIosAppStoreId: (state: RootState) => string | undefined | null = createSelector(getCurrentApp, (app) => {
  return app?.ios_app_store_id;
});
export const selectAppStoreCountry: (state: RootState) => string | undefined = createSelector(getCurrentApp, (app) => {
  return app?.apple_store_country;
});
export const getWebUrl: (state: RootState) => string = createSelector(getCurrentApp, (app) => {
  const activeDesktopDeepview = app?.deepview_desktop ? `Deepview '${app.deepview_desktop}'` : null;
  return app?.default_desktop_url || activeDesktopDeepview || 'Branch-hosted, default TMTA';
});

export const selectAppZuoraAccountId = createSelector<any, App | null | undefined, string | null | undefined>(
  getCurrentApp,
  (currentApp) => currentApp && currentApp.zuora_account_id
);

export const selectHasZuoraAccount = createSelector<any, string | null | undefined, boolean>(
  selectAppZuoraAccountId,
  (zuoraAccountId) => !!zuoraAccountId
);

export const selectIsLiveApp = createSelector<any, App | null | undefined, boolean | null | undefined>(
  getCurrentApp,
  (currentApp) => currentApp && currentApp.live_id === currentApp.id
);

export const selectBranchKey = createSelector<any, App | null | undefined, string | null>(
  getCurrentApp,
  (currentApp) => (currentApp && currentApp.branch_key) || null
);

export const selectBranchSecret = createSelector<any, App | null | undefined, string | null>(
  getCurrentApp,
  (currentApp) => (currentApp && currentApp.branch_secret) || null
);

export const getDefaultDomain: (state: RootState) => string | undefined = createSelector(
  getCurrentApp,
  (currentApp) => (currentApp && currentApp.default_short_url_domain) || undefined
);

export const getCustomDomain: (state: RootState) => string | undefined = createSelector(
  getCurrentApp,
  (currentApp) => (currentApp && currentApp.short_url_domain) || undefined
);

export const selectAppTimezone: (state: RootState) => string | undefined = createSelector(
  getCurrentApp,
  (currentApp) => (currentApp && currentApp.timezone) || undefined
);
